// region Please kill jQuery

// import $ from 'jquery';
// import { Foundation } from 'foundation-sites/js/foundation.core';
// import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
// import { Keyboard } from 'foundation-sites/js/foundation.util.keyboard';
// import { Triggers } from 'foundation-sites/js/foundation.util.triggers';
// import { OffCanvas } from 'foundation-sites/js/foundation.offcanvas';

// Set up Foundation with jQuery.
// Foundation.addToJquery($);
// Foundation JS init here:
// Foundation.MediaQuery = MediaQuery;

// ...
// $(document).foundation();
// // Add jQuery to window for temp back compat.
// window.$ = $;

// endregion

import * as Tools from './tools';
import 'lazysizes';
import initAnalytics from './analytics/analytics';
import initLightbox from './plugins/lightbox';
import initMenu from './plugins/menu';
import {initInviewObserver} from "./IntersectionObserver";
import {initModal} from './plugins/modal';
import {
    initHomePageSlider,
    initGalleryElementCarousel1,
    initGalleryElementCarousel2,
    initEmployeeSlider,
    initPackageGallerySlider,
    initColumnSliderElement,
    initImageSliderElement,
    initExpandingColumnElementSwiper, initPackageSlider, initMapMarkerSlider
} from './plugins/carousels'
import {initAnimationObserver} from "./plugins/animation";
import {initSweetAlert} from "./plugins/sweetalert";
import initPageform from "./plugins/pageform";
import initListFilter from "./plugins/listfilter";
import {initStickyHeader} from "./plugins/stickyheader";
import {initExpandingColumnElement} from "./plugins/columnelement";
import {initExpandingListElement} from "./plugins/expandinglistlement";
import {initDragableCta} from "./plugins/dragable";
import {initShowMoreGrid} from "./plugins/showmoregrid";
import {initExpandingColumnElement2} from "./plugins/columnelement2";
import {initShowText} from "./plugins/showtext";
import {initMapScroll} from "./plugins/mapscroll";


window.Tools = Tools;

document.addEventListener('DOMContentLoaded', () => {
    initExpandingListElement();
    initDragableCta();
	initAnalytics();
    initInviewObserver();
    initAnimationObserver();
    initSweetAlert();
	initPageform();
    initLightbox();
	initMenu();
    initStickyHeader();
	initModal();
    initHomePageSlider();
    initPackageGallerySlider();
    initEmployeeSlider();
    initGalleryElementCarousel1();
    initGalleryElementCarousel2();
    initListFilter();
    initExpandingColumnElement();
    initExpandingColumnElement2();
    initColumnSliderElement();
    initImageSliderElement();
    initShowMoreGrid();
    initShowText();

    initExpandingColumnElementSwiper();
    initPackageSlider();
    initMapMarkerSlider();
});

// If in development mode, enable live reload
if (ENV !== 'production') {
    document.write(
        '<script src="http://' + (location.host || 'localhost').split(':')[0] +
        ':35729/livereload.js?snipver=1"></' + 'script>'
    );
}

//Focus on Search window load
window.onload = function() {
    var input = document.getElementById("SearchForm_SearchForm_Search");
    if (input) {
        input.setAttribute("placeholder", "Enter a search phrase here");
        input.focus();
        var val = input.value; //store the value of the element
        input.value = ''; //clear the value of the element
        input.value = val; //set that value back.
    }
}
